import { Entity } from '@core/entities/entity'
import { IObservationStatsTasks } from './IObservationStatsTasks'
import { plainToInstance } from 'class-transformer'

export class ObservationStatsTasks extends Entity<IObservationStatsTasks> {
  open: number
  overdue: number
  resolvedOnTimePercentage: number

  public static new(payload: unknown): ObservationStatsTasks {
    const entity = plainToInstance(ObservationStatsTasks, payload)

    return entity
  }
}
